'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _titleSection = require('../common/title-section');

var _titleSection2 = _interopRequireDefault(_titleSection);

var _bodySection = require('../common/body-section');

var _bodySection2 = _interopRequireDefault(_bodySection);

var _ctaSection = require('../common/cta-section');

var _ctaSection2 = _interopRequireDefault(_ctaSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'How To Sign Online SEO Page',

    renderTitleSection: function renderTitleSection() {
        var titleSectionProps = {
            title: 'How to Sign Online',
            subtitle: 'Ready to start signing online? Set up your HelloSign account to create your first document.',
            buttonText: 'TRY HELLOSIGN'
        };
        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
    },
    renderBodySection: function renderBodySection() {
        var headerClass = 'm-marketing-page--header';
        var listClass = 'm-marketing-page--list';
        return _react2['default'].createElement(
            _bodySection2['default'],
            null,
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'What is HelloSign?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'HelloSign was created to make it easy to sign all your most important documents online. We know what a pain it is to run back and forth from the printer and scanner (if you even have one!) when completing paperwork. We also know some admin software can get complicated quickly. To solve these pain points, we focused on making a simple, sleek eSignature app that\u2019s easy to navigate.'
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'How do I Sign Documents Online?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'It\u2019s super easy to start signing online! Just create a free HelloSign account, upload your document, and format the document with a signature box in the appropriate area. Once you have a signature in place, you can either insert your own signature or send the document to another party to get their signature.'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'There are a few different ways to create a signature which you can ',
                _react2['default'].createElement(
                    'a',
                    {
                        href: 'http://blog.hellosign.com/signature-maker/',
                        target: '_blank', rel: 'noopener noreferrer' },
                    'learn about here.'
                )
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'What kind of documents can I sign online?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'You can sign all sorts of documents online! A few popular examples are offer letters and contracts, but it doesn\u2019t stop there. Our customers have used HelloSign to sign:'
            ),
            _react2['default'].createElement(
                'ul',
                { className: listClass },
                _react2['default'].createElement(
                    'li',
                    null,
                    'Vendor applications'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Escrow paperwork'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Mortgage '
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Employee benefits paperwork'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Lease'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Plus more!'
                )
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'Is it secure to sign my documents online?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'Yep! HelloSign provides bank-level security to keep your information safe and secure. We also offer additional features that ensure that you always have full control over the journey of your document. These features include:'
            ),
            _react2['default'].createElement(
                'ul',
                { className: listClass },
                _react2['default'].createElement(
                    'li',
                    null,
                    _react2['default'].createElement(
                        'strong',
                        null,
                        'Time stamped audit-trails'
                    ),
                    ' to give you an overview of every touchpoint of your document.'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    _react2['default'].createElement(
                        'strong',
                        null,
                        'User permissions'
                    ),
                    ' to securely share sensitive documents with included parties.'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    _react2['default'].createElement(
                        'strong',
                        null,
                        'Two factor authentication'
                    ),
                    ' as an added protection against for log-ins.'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    _react2['default'].createElement(
                        'strong',
                        null,
                        'Signer order'
                    ),
                    ' to ensure that the person you want signing is getting the document at the right time.'
                )
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'What types of industries use eSignatures to sign online?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'A lot! As eSignatures become the norm for signing, most industries have adopted some form of electronic signing. The cost and time savings associated with having an entirely electronic workflow are also huge! We\u2019ve had users cut the document turnaround time with their clients from over a month to less than a day.'
            )
        );
    },
    renderCTASection: function renderCTASection() {
        var ctaSectionProps = {
            title: 'Get Started',
            subtitle: 'Ready to try signing online for yourself? You can sign up for a free account to test it out. For unlimited documents and templates, take a look at our pro plans.',
            signupButtonText: 'CREATE A HELLOSIGN ACCOUNT',
            signupButtonUrl: this.props.homeUrl,
            secondButtonText: 'SEE PRO PLANS',
            secondButtonUrl: this.props.pricingUrl
        };
        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
    },
    render: function render() {
        return _react2['default'].createElement(
            'div',
            null,
            this.renderTitleSection(),
            this.renderBodySection(),
            this.renderCTASection()
        );
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/seo/how-to-sign-online.jsx
 ** module id = 1223
 ** module chunks = 0
 **/